import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { MfgModel } from '../models/mfg.model';

@Injectable({
  providedIn: 'root'
})
export class MfgService extends BaseService {
  private baseUrl = '/mfg';

  getMfg(): Observable<MfgModel[]> {
    return this.baseGet<MfgModel[]>(`${this.baseUrl}`);
  }

  postContribuicoes(body: any): Observable<any> {
    return this.basePost(`${this.baseUrl}/contribuicao`, body);
  }
}
